import api from "@/app/api";
import Guid from "@/app/types/common/guid";
import { Instant, LocalDate, LocalTime } from "@js-joda/core";
import {ModelObject, BaseModelObject, ValidationRule} from "@/app/services/modelObject";
import ServiceBase from "@/app/services/serviceBase";
import converters from "@/app/services/converters"

// Model Objects

export class InvoiceFieldRequirement extends ModelObject<InvoiceFieldRequirement> {

    public show: boolean = false;
    public required: boolean = false;

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.show = jsonSerializedObject.show;
          this.required = jsonSerializedObject.required;
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.show = this.show;
        toRet.required = this.required;
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
    ];
}


export class InvoiceRequirements extends ModelObject<InvoiceRequirements> {

    public invoiceRecipientTaxNumber: InvoiceFieldRequirement = new InvoiceFieldRequirement();

    public constructor(jsonSerializedObject?: any) {
        super();
        if (jsonSerializedObject) {
          this.invoiceRecipientTaxNumber = new InvoiceFieldRequirement(jsonSerializedObject.invoiceRecipientTaxNumber);
        }

    }

    public toJsonSerializedObject(): any {
        const toRet = {} as any;
        toRet.invoiceRecipientTaxNumber = this.invoiceRecipientTaxNumber.toJsonSerializedObject();
        return toRet;
    }

    public toProto(): any {
      return this.toJsonSerializedObject();
    }

    public toBinary(): Uint8Array {
      return new TextEncoder().encode(JSON.stringify(this.toJsonSerializedObject()));
    }

    public validationRules: ValidationRule = [
            {field: "invoiceRecipientTaxNumber", rule: (v: any) => !!v || "invoiceRecipientTaxNumber is required"},
            {field: "invoiceRecipientTaxNumber", rule: (v: any) => v.validate()},
    ];
}


export class InvoiceRulesService extends ServiceBase {

  public async getInvoiceRequirements(tenantId: Guid, opts?: {requestTimeoutMs?: number, sessionToken?: string}): Promise<InvoiceRequirements> {
    const req = {
    tenantId:tenantId.toString(),
    };
    const extractor = (response:any) => new InvoiceRequirements(response.requirements);;
    return this.makeJsonRequest("invoiceRules/v1/getInvoiceRequirements", req, false, extractor, opts);
  };
}

export const invoiceRulesService = new InvoiceRulesService();